import { render } from "./TeoConnect.vue?vue&type=template&id=08b23656&scoped=true"
import script from "./TeoConnect.vue?vue&type=script&lang=js"
export * from "./TeoConnect.vue?vue&type=script&lang=js"

import "./TeoConnect.vue?vue&type=style&index=0&id=08b23656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b23656"]])

export default __exports__